import React from 'react';
import {ILinkItem} from "../interfaces/ILinkItem";
import Link from "next/link";
import Button from "./Button";
import {toast} from "react-toastify";


interface LinkComponentProps {
  link: ILinkItem;
  children: any;
}

const LinkComponent: React.FC<LinkComponentProps> = (props: LinkComponentProps) => {
  const {link, children} = props;
  const getTarget = (type: ILinkItem['type']) => {
    switch (type) {
      case 'BLANK':
        return '_blank';
      case 'EXTERNAL':
        return '_blank';
      case 'RESOURCE':
        return '_blank';
      case 'INTERNAL':
        return '_self';
      case 'DOWNLOAD':
        return '_self';
      default:
        return '_self';
    }
  };

  const handleHeadlessRequest = async () => {
    const res = await fetch(link.href)

    if (res.ok) {
      try {
        const data = await res.json()
        if (data.message && data.showConfirmation)
        toast(data.message, {
          type: data.type,
          autoClose: 5000
        })
      } catch (e) {
       // do nothing, no body
      }
    }
  }

  const handleDownload = (url: string) => {
    const a = document.createElement('a');
    a.href = url;
    a.download = ''; // Let the browser decide the file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  if (link.type === 'HEADLESS') {
    // Make a REST request + render button instead of link for the entry
    return (
    <Button variant={"transparent"}
            onClick={handleHeadlessRequest}
            className={"p-0"}>
      {children}
    </Button>
    )
  }

  if (link.type === 'DOWNLOAD') {
    return (
      <Button variant={"underline"}
              onClick={() => handleDownload(link.href)}
              className={"p-0"}>
        {children}
      </Button>
    );
  }

  return (
    <Link href={link.href} target={getTarget(link.type)}>
      {children}
    </Link>
  );
};

export default LinkComponent;
